export const GOOGLE_MAPS_SEARCH_URL = 'https://www.google.com/maps';
export const GOOGLE_SEARCH_URL = 'https://www.google.com/search';
